export const LOAD_SUBSCRIPTON_DETAILS = 'LOAD_SUBSCRIPTON_DETAILS';
export const LOAD_CURRENT_PLAN_DETAILS = 'LOAD_CURRENT_PLAN_DETAILS';
export const LOAD_AVAILABLE_PLANS = 'LOAD_AVAILABLE_PLANS';
export const LOAD_TAB_DATA = 'LOAD_TAB_DATA';
export const LOAD_SELECTED_PLAN = 'LOAD_SELECTED_PLAN';
export const UPDATE_CREDITS_AVAILABLE = 'UPDATE_CREDITS_AVAILABLE';
